export default "__VITE_ASSET__CnSPXNLZ__"